module.exports = __webpack_public_path__ + "img/error.10419157.svg";